import React from 'react'
import TaskTemplateGrid from '../components/grids/TaskTemplateGrid'

const TaskTemplateSettingsPage = () => {
    return (
        <div id='settings-task-templates-page' className='stretched row-based container'>
            <TaskTemplateGrid />
        </div>
    )
}

export default TaskTemplateSettingsPage
